import type { PagePerformanceReport, PageVisibilityReport } from "~/api/Api";

export type MetricBand = "good" | "warn" | "bad";

// Visual band by fill value, used for the per-row bar color.
// Tooltips and the dashboard donut still surface the backend's labeled
// segment/score verdict via visibilityBand / performanceBand below.
export function bandFromValue(value: number): MetricBand {
  if (value >= 0.67) return "good";
  if (value >= 0.34) return "warn";

  return "bad";
}

export function visibilityBand(
  segment: PageVisibilityReport["segment"],
): MetricBand {
  switch (segment) {
    case "fully_accessible":
      return "good";
    case "partially_accessible":
      return "warn";
    case "js_dependent":
      return "bad";
  }
}

export function performanceBand(
  score: PagePerformanceReport["score"],
): MetricBand {
  switch (score) {
    case "good":
      return "good";
    case "ok":
      return "warn";
    case "poor":
      return "bad";
  }
}

// Site-level performance verdict from raw averages. Mirrors the per-page
// thresholds in Pages::PerformanceScore (API) — kept in sync manually since
// the site aggregate endpoint doesn't yet expose a derived score field.
// content_load uses the same thresholds as page_load per the API spec.
export function perfBandFromMetrics(
  absoluteTtfb: number,
  contentLoad: number,
): MetricBand {
  if (absoluteTtfb <= 800 && contentLoad <= 1500) return "good";
  if (absoluteTtfb <= 1800 && contentLoad <= 3000) return "warn";

  return "bad";
}

// Performance has no native 0..1 metric, so map the categorical score to
// indicative fill levels. Visibility uses text_ratio directly.
export function performanceFill(score: PagePerformanceReport["score"]): number {
  switch (score) {
    case "good":
      return 0.92;
    case "ok":
      return 0.55;
    case "poor":
      return 0.22;
  }
}

export function visibilitySegmentLabel(
  segment: PageVisibilityReport["segment"],
): string {
  switch (segment) {
    case "fully_accessible":
      return "Fully accessible";
    case "partially_accessible":
      return "Partially accessible";
    case "js_dependent":
      return "JS-dependent";
  }
}

export function performanceScoreLabel(
  score: PagePerformanceReport["score"],
): string {
  switch (score) {
    case "good":
      return "Good";
    case "ok":
      return "OK";
    case "poor":
      return "Poor";
  }
}
